/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IFooterCategoryViewProps } from '@msdyn365-commerce-modules/footer/src/modules/footer-category/./footer-category';
import { IFooterCategoryProps } from '../definition-extensions/footer-category.ext.props.autogenerated';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

export const FooterCategoryView: React.FC<IFooterCategoryViewProps & IFooterCategoryProps<{}>> = props => {
    const { categories, FooterList, FooterListItem } = props;
    if (!categories || categories.length === 0) {
        props.context.telemetry.error('Footer content is empty, module wont render');
        return null;
    }
    if (ArrayExtensions.hasElements(props.slots.banner)) {
        return (
            <div className='footer-with-banner'>
                <div className={'footer-list'}>
                    <Module {...FooterList}>
                        {categories.map((category: ReactNode, index: number) => {
                            return (
                                <Node {...FooterListItem} key={index}>
                                    {category}
                                </Node>
                            );
                        })}
                    </Module>
                </div>
                <div className={'banner'}>{props.slots.banner[0]}</div>
            </div>
        );
    } else {
        return (
            <Module {...FooterList}>
                {categories.map((category: ReactNode, index: number) => {
                    return (
                        <Node {...FooterListItem} key={index}>
                            {category}
                        </Node>
                    );
                })}
            </Module>
        );
    }
};

export default FooterCategoryView;
